// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__oxy8j","main":"Video_main__0VyWk"};